import { render, staticRenderFns } from "./PaymentMethodChooser.vue?vue&type=template&id=d7a4b5e4&"
import script from "./PaymentMethodChooser.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports